/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconFilter = StyledIconInline.extend`
  height: ${props => props.height || '23px'};
  width: ${props => props.width || '24px'};
`;

export const IconFilter = (props) => (
    <StyledIconFilter {...props}>
        <svg viewBox="0 0 24 23" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M23.2783,3.896 C23.2783,2.387 18.2263,0.521 11.9993,0.521 C5.7723,0.521 0.7193,2.387 0.7193,
                3.896 L0.7193,3.979 C0.7193,6.633 8.0173,12.847 9.3453,15.5 L9.3453,20.198 C9.3453,21.944 14.6523,
                21.947 14.6523,20.198 L14.6523,15.5 C15.9803,12.847 23.2783,6.633 23.2783,3.979 L23.2783,3.896 Z"/>
                <path d="M2.186,4.2905 C3.769,7.1735 20.229,7.1735 21.812,4.2905"/>
            </g>
        </svg>
    </StyledIconFilter>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconFilter/index.js